import ADRBasic from "components/hospitality/rooms/controls/adr-basic"
import ADRDetailedAnnual from "components/hospitality/rooms/controls/adr-detailed-annual"
import ADRDetailedMonthly from "components/hospitality/rooms/controls/adr-detailed-monthly"
import DeleteConfirmation from "components/modal/delete-confirmation"
import OccupancyBasic from "components/hospitality/rooms/controls/occupancy-basic"
import OccupancyDetailedAnnual from "components/hospitality/rooms/controls/occupancy-detailed-annual"
import OccupancyDetailedMonthly from "components/hospitality/rooms/controls/occupancy-detailed-monthly"
import RoomsAreaBasic from "components/hospitality/rooms/controls/rooms-area-basic"
import RoomsAreaDetailed from "components/hospitality/rooms/controls/rooms-area-detailed"

export default {
  ADRBasic,
  ADRDetailedAnnual,
  ADRDetailedMonthly,
  DeleteConfirmation,
  OccupancyBasic,
  OccupancyDetailedAnnual,
  OccupancyDetailedMonthly,
  RoomsAreaBasic,
  RoomsAreaDetailed
}
